import React from 'react'
import { capitalize } from 'lodash'
import { Link, Redirect } from 'react-router-dom'
import Paper from 'material-ui-legacy/Paper'
import Row from 'muicss/lib/react/row'
import Col from 'muicss/lib/react/col'
import LinearLoader from '../UI/LinearLoader'

import { formatDate } from '../../lib/formats'
import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import ProjectNotFound from './ProjectNotFound'
import BackButton from '../UI/BackButton'
import EditButton from '../UI/EditButton'
import PageTitle from '../UI/PageTitle'
import PlainText from '../UI/PlainText'
import QuotesPager from '../Quotes/QuotesPager'

import Resource from '../../stores/resource'
const ProjectStore = Resource('projects')

class ShowProjectPage extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      project: null,
      loading: true,
      error: '',
      redirect: ''
    }
  }

  loadProject(id)
  {
    this.setState({
      project: null,
      loading: true
    })
    ProjectStore.findBy({ id: id }, [
      'client',
      'agency',
      'agencyProducer',
      'directorOne',
      'directorTwo',
      'user'
    ])
    .then(result =>
      {
        this.setState({
          project: result.data,
          loading: false
        })
        this.forceUpdate()
      }
    )
    .catch(error =>
      this.setState({
        project: null,
        loading: false,
        error: errors.unpack(error)
      })
    )
  }

  componentWillReceiveProps(nextProps, nextContext)
  {
    this.loadProject(nextProps.match.params.id);
  }

  /*
  componentWillReceiveProps(nextProps, nextContext)
  {
//    console.log(nextProps)
    this.setState({ loading: true, project: null }, () =>
    {
      ProjectStore.findBy({ id: nextProps.match.params.id }, [
        'client',
        'agency',
        'agencyProducer',
        'user'
      ])
        .then(result =>
          this.setState({
            project: result.data,
            loading: false
          })
        )
        .catch(error =>
          {
		console.log(error)
          this.setState({
            project: null,
            loading: false,
            error: errors.unpack(error)
          })
          }
        )
    })
  }
  */

  componentDidMount()
  {
    this.loadProject(this.props.match.params.id);
  }

  _redirectTo = url => {
    this.setState({ redirect: url })
  }

  render() {
    const { loading, error, redirect, project } = this.state

    if (loading) return <LinearLoader />
    if (redirect) return <Redirect push to={redirect} />
    if (!project) return <ProjectNotFound />

    const client = project.included('client')
    const agency = project.included('agency')
    const agencyProducer = project.included('agencyProducer')
    const user = project.included('user')
    const directorOne = project.included('directorOne')
    const directorTwo = project.included('directorTwo')

    const paperStyle = {
      width: '99%',
      padding: '10px',
      overflow: 'auto',
      marginTop: '5px'
    }

    return (
      <section>
        <Row>
          <Col sm="10" md="9" lg="10">
            <header>
              <PageTitle>
                Project: {project.attributes.name} (Docket #{project.attributes.formattedDocketNo})
              </PageTitle>
            </header>
          </Col>
          <Col sm="2" md="3" lg="2" style={{ textAlign: 'right' }}>
            <EditButton
              style={{ marginTop: '23px' }}
              onTouchTap={() =>
                this._redirectTo(`/projects/${project.id}/edit`)
              }
            />
          </Col>
        </Row>
        <Row style={{ marginBottom: '40px' }}>
          <Col sm="12">
            <Paper
              style={{
                padding: '10px',
                marginBottom: '20px',
                marginTop: '20px'
              }}
            >
              <p>
                <strong>State:</strong> {capitalize(project.attributes.state)}
              </p>

              <p>
                <strong>Project Type:</strong>{' '}
                {project.attributes.projectTypeName}
              </p>

              <p>
                <strong>Campaign:</strong> {project.attributes.campaign}
              </p>

              <p>
                <strong>Product:</strong> {project.attributes.product}
              </p>

              <p>
                <strong>Client:</strong>
                &nbsp;
                <Link to={`/clients/${project.attributes.clientId}`}>
                  {client.attributes.name}
                </Link>
              </p>

              <p>
                <strong>Agency:</strong>
                &nbsp;
                <Link to={`/agencies/${project.attributes.agencyId}`}>
                  {agency.attributes.name}
                </Link>
              </p>

              {project.attributes.agencyProducerId && (
                <p>
                  <strong>External project manager:</strong>
                  &nbsp;
                  <Link
                    to={`/agency-producers/${
                      project.attributes.agencyProducerId
                    }`}
                  >
                    {agencyProducer.attributes.fullName}
                  </Link>
                </p>
              )}

              {project.attributes.userId && (
                <p>
                  <strong>Internal Producer:</strong> {user.attributes.fullName}
                </p>
              )}

              {project.attributes.directorOneId && (
                <p>
                  <strong>Primary Director:</strong> {directorOne.attributes.fullName}
                </p>
              )}
              {project.attributes.directorTwoId && (
                <p>
                  <strong>Secondary Director:</strong> {directorTwo.attributes.fullName}
                </p>
              )}


              <p>
                <strong>Date:</strong> {formatDate(project.attributes.date)}
              </p>

              <p>
                <strong>Last Updated:</strong>{' '}
                {formatDate(project.attributes.updatedAt)}
              </p>

              {project.attributes.jobDescription && (
                <p>
                  <strong>Job description:</strong>
                  <Paper style={paperStyle}>
                    <PlainText
                      text={project.attributes.jobDescription}
                      wrapText={120}
                    />
                  </Paper>
                </p>
              )}

              {project.attributes.description && (
                <p>
                  <strong>Requisition (internal):</strong>
                  <Paper style={paperStyle}>
                    <PlainText
                      text={project.attributes.description}
                      wrapText={120}
                    />
                  </Paper>
                </p>
              )}
            </Paper>
          </Col>
          <Col sm="12">
            <QuotesPager projectId={project.id} />
          </Col>
        </Row>

        <BackButton />
        <BackButton
          style={{ marginLeft: '15px' }}
          label="Project list"
          onTouchTap={() => this._redirectTo('/projects')}
        />

        <ErrorDialog
          open={Boolean(error)}
          closeCallback={this._closeErrorDialog}
        >
          <p>
            <strong>Error:</strong> {error}
          </p>
        </ErrorDialog>
      </section>
    )
  }
}

export default ShowProjectPage



// WEBPACK FOOTER //
// ./src/components/Projects/ShowProjectPage.jsx